import { useState } from "react";
import Seo from "../lib/Seo";
import useReveal from "../lib/useReveal";
import { sendContact, CONTACT_EMAIL } from "../lib/api";
import { Arrow } from "../components/Icons";

const TYPES = [
  { value: "general", label: "General enquiry" },
  { value: "partnership", label: "Partnership" },
  { value: "manufacturing", label: "Manufacturing" },
  { value: "media", label: "Media / podcast" },
];

export default function Contact() {
  useReveal();
  const [form, setForm] = useState({ name: "", email: "", enquiry_type: "general", message: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async () => {
    setErr("");
    if (!form.name.trim()) return setErr("Please add your name.");
    if (!form.email.trim() || !form.email.includes("@")) return setErr("Please add a valid email address.");
    if (!form.message.trim()) return setErr("Please add a message.");
    setBusy(true);
    try {
      await sendContact(form);
      setDone(true);
    } catch (e) {
      setErr("Something went wrong. Please try again, or email us directly.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Seo
        title="Contact | Dialed In"
        description="Get in touch with Dialed In — general enquiries, partnerships, manufacturing and media."
      />
      <section className="page-head" data-testid="contact-page">
        <div className="wrap">
          <div className="label rv rv-up">Contact</div>
          <h1 className="disp page-h rv rv-up">Talk to <span className="g">Dialed In.</span></h1>
          <p className="page-sub rv rv-up">
            Questions, partnerships, manufacturing or media — every message lands with Jason. You can also email{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: "var(--gold-hi)" }} data-testid="contact-email-link">{CONTACT_EMAIL}</a> directly.
          </p>
        </div>
      </section>

      <section className="sec sec-2" data-testid="contact-form-section">
        <div className="wrap-narrow">
          {done ? (
            <div className="ty-block" data-testid="contact-thankyou">
              <h3 className="ty-head">Received.</h3>
              <p className="ty-body">Thanks for reaching out — your message is with Jason. You'll hear back at the email you gave us.</p>
            </div>
          ) : (
            <div className="rv rv-up">
              <input type="text" className="field" placeholder="Your name" value={form.name} onChange={set("name")} data-testid="contact-name" />
              <input type="email" className="field" placeholder="Email address" value={form.email} onChange={set("email")} data-testid="contact-email" />
              <select className="field" value={form.enquiry_type} onChange={set("enquiry_type")} data-testid="contact-type" aria-label="Enquiry type">
                {TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
              <textarea className="field" placeholder="Your message" rows={5} value={form.message} onChange={set("message")} data-testid="contact-message" />
              <div className="submit-row">
                <button className="cta" onClick={submit} disabled={busy} data-testid="contact-submit-btn">
                  {busy ? "Sending" : "Send message"} <Arrow />
                </button>
              </div>
              <p className={`form-fine${err ? " err" : ""}`} data-testid="contact-fine">
                {err || "We reply to everything. No message goes into a void."}
              </p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
